import { render, staticRenderFns } from "./GlassdesignLogo.vue?vue&type=template&id=080f37e0&scoped=true&"
var script = {}
import style0 from "./GlassdesignLogo.vue?vue&type=style&index=0&id=080f37e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080f37e0",
  null
  
)

export default component.exports